import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { movies, type ContentType } from '@/mocks/movies';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntry from './components/CategoryEntry';
import HotSection from './components/HotSection';
import LatestSection from './components/LatestSection';
import SiteIntro from './components/SiteIntro';

export default function Home() {
  const featured = movies.filter((m) => m.backdrop).slice(0, 5);
  const hot = [...movies].sort((a, b) => b.hot - a.hot).slice(0, 10);
  const latest = [...movies].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime(),
  );

  const counts: Record<ContentType, number> = {
    movie: movies.filter((m) => m.type === 'movie').length,
    tv: movies.filter((m) => m.type === 'tv').length,
    variety: movies.filter((m) => m.type === 'variety').length,
  };

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <HeroCarousel items={featured} />
        <CategoryEntry counts={counts} />
        <HotSection items={hot} />
        <LatestSection items={latest} />
        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}